import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import SubmitSms from '../pages/Authentication/SubmitSms'
import SubmitPackage from '../pages/GasProjects/SP'
import TransactionPublic from '../pages/Accounting/TP'

// Home Page

// Dashboard
import Dashboard from "../pages/Dashboard/index"


// Channels

// Auctions

// pages
import USERs from "../pages/Users/index"
import Projects from "pages/Projects"
import GasProjects from "pages/GasProjects"
import GasProjectProcessEng from "pages/GasProjectProcessEng"
import GasProjectDashboardEng from "pages/GasProjectProcessEng/GasProject"
import GasProjectProcessList from "pages/GasProjectProcessList"
import GasProjectProcessListView from "pages/GasProjectProcessListView"
import Accounting from "pages/Accounting"
import EngAccountingDashboard from "pages/EngAccountingDashboard"
import BaseInfo from "pages/BaseInfo"
import Reports_gasProjects from 'pages/Reports/gasProjects'
import Reports_engInvoice from 'pages/Reports/accounting'
import GasProjectProcess from "pages/GasProjectProcess"
import GasProjectDashboardProcess from "pages/GasProjectProcess/GasProject"
import Reports_Engineers from 'pages/Reports/engineers'
import ReportsAdministrator from 'pages/Reports/administrator'
import EngWork from "pages/EngWork"
import Support from 'pages/Support'
import SupportMessage from "pages/Support/Messages"
import EngPayment from "pages/EngPayment"
import GasProjectExecutor from "pages/GasProjectExecutor"
import GasProjectDashboardExe from "pages/GasProjectExecutor/GasProject"
import GasProjectInstaller from "pages/GasProjectInstaller"
import GasProjectGisIndex from "../pages/GasProjectGis/index"
import PipingPlan from "pages/PipingPlan"
import Notifications from "pages/Notifications"
import AiTraining from "pages/AiTraining"
import GitCommits from "pages/GitCommits"
import QuarterTariffs from "pages/QuarterTariffs"
import ProjectPackageList from "pages/ProjectPackage"
import ListGasProjectNezarat from "pages/GasProjectNezarat"

const userRoutes = [
  {id:1001,parent_id:null,title:"داشبورد",icon: "DashboardOutlined", path: "/dashboard",
  component: Dashboard ,roles:['Administrator', 'Executor', 'Engineer','Employee', 'Accountant', 'Section','Installer','Administrative','Nezam',"Nezarat"],hide:false,isQuickAction:true },

   // Package Installer
    {id:1024,parent_id:null, title:"پکیج‌ های من",icon: "WaterHeater", path: "/project-packages", component: ProjectPackageList,roles:['Installer'],isQuickAction:true ,hide:false},
    {id:1018,parent_id:null, title:"لیست پرونده",icon: "UnorderedListOutlined", path: "/projects/GasProjectInstaller", component: GasProjectInstaller,roles:['Installer'],isQuickAction:true ,hide:false},


  // {id:1002,parent_id:null,title:"BaseInfo",icon:"ti-settings", path: "/BaseInfo",roles:['Administrator', 'Accountant' ],hide:false},
  {id:1002,parent_id:null,title:"اطلاعات پایه",icon: "SettingOutlined", path: "/BaseInfo/ExeEng", component: BaseInfo,roles:['Administrator', 'Accountant', 'Administrative' ],hide:false,isQuickAction:true },
  
  {id:1003,parent_id:null,title:"پرونده نظارت",icon: "FolderOutlined", path: "/projects", component: Projects,roles:['Administrator','Executor', 'Engineer', 'Employee', 'Section', 'Accountant','Administrative' ],hide:false,isQuickAction:true },
    {id:100301,parent_id:1003, title:"پیش ثبت نام",icon: "FileAddOutlined", path: "/projects/create", component: Projects,roles:['Executor'],hide:false},
    {id:100302,parent_id:1003, title:"پرونده های من",icon: "FileTextOutlined", path: "/projects/GasProjects", component: GasProjects,roles:['Administrator',  'Employee', 'Accountant','Administrative'],hide:false},
    {id:100303,parent_id:1003, title:"لیست پرونده",icon: "UnorderedListOutlined", path: "/projects/GasProjectExecutor", component: GasProjectExecutor,roles:['Executor'],hide:false},
    {id:100304,parent_id:1003, title:"پرونده مجری",icon: "FileTextOutlined", path: "/projects/GasProjectExecutor/:id", component: GasProjectDashboardExe,roles:['Executor'],hide:true},
    {id:100305,parent_id:1003, title:"لیست تخصیص",icon: "ProfileOutlined", path: "/projects/GasProjectProcessEng", component: GasProjectProcessEng,roles:[ 'Engineer'],hide:false},
    {id:100306,parent_id:1003, title:"تخصیص",icon: "ProfileOutlined", path: "/projects/GasProjectProcess", component: GasProjectProcess,roles:[ 'Administrator', 'Employee', 'Accountant', 'Section','Administrative'],hide:false},
    {id:100307,parent_id:1003, title:"لیست تخصیص ها",icon: "UnorderedListOutlined", path: "/projects/GasProjectProcessList", component: GasProjectProcessList,roles:[ 'Administrator'],hide:false},
    {id:100308,parent_id:1003, title:"پکیج‌ها و نصاب",icon: "ToolOutlined", path: "/projects/GasProjectProcess/:id", component: GasProjectDashboardProcess,roles:['Administrator', 'Employee', 'Section', 'Accountant', 'Administrative'],hide:true},

  {id:1004,parent_id:null,title:"کارکرد مهندسین",icon: "PlayCircleOutlined", path: "/EngWork", component: EngWork,roles:['Administrator', 'Engineer', 'Accountant', 'Nezarat'] ,hide:false,isQuickAction:true },
    // Quarter Tariffs Management (Administrator only)
  {id:1005,parent_id:null, title:"مدیریت تخصیص‌ها",icon: "ScheduleOutlined", path: "/quarter-tariffs", component: QuarterTariffs,roles:['Administrator'],hide:false},

  {id:1006,parent_id:null,title:"حسابداری من",icon: "WalletOutlined", path: "/accounting", component: Accounting,roles:['Administrator','Executor', 'Accountant'] ,hide:false},
  {id:1007,parent_id:null,title:"داشبورد مالی",icon: "WalletOutlined", path: "/eng-accounting", component: EngAccountingDashboard,roles:['Engineer'] ,hide:false, isQuickAction:true },
  // {id:1008,parent_id:null,title:"Learning",icon:"ti-control-play", path: "/learning", component: Learning,roles:['Administrator','Executor', 'Engineer', 'Employee', 'Accountant'] },
  {id:1008,parent_id:null,title:"پشتیبانی",icon: "CommentOutlined", path: "/support", component: Support,roles:['Administrator','Executor', 'Engineer', 'Employee', 'Accountant', 'SuperUser', 'Installer','Administrative'] ,hide:false},
  {id:100801,parent_id:null,title:"پشتیبانی",icon: "CommentOutlined", path: "/support/:id", component: SupportMessage,roles:['Administrator','Executor', 'Engineer', 'Employee', 'Accountant', 'SuperUser', 'Installer','Administrative'], hide:true},


  {id:1009,parent_id:null,title:"گزارشات", icon: "FileSearchOutlined", path:"/reports",roles:['Administrator','Accountant', 'Engineer'],hide:false},
    {id:100901,parent_id:1009,title:"پرونده ها", icon: "FileTextOutlined", path:"/reports/gasProjects", component: Reports_gasProjects,roles:['Administrator'],hide:false},
    {id:100902,parent_id:1009,title:"کارشناسان", icon: "DatabaseOutlined", path:"/reports/engInvoices", component: Reports_engInvoice,roles:['Accountant'],hide:false},
    {id:100903,parent_id:1009,title:"لیست گزارشات", icon: "DatabaseOutlined", path:"/reports/engReports", component: Reports_Engineers,roles:['Engineer','Administrator',  'Accountant'],hide:false},
    {id:100904,parent_id:1009,title:"گزارش مدیریت", icon: "BarChartOutlined", path:"/reports/admin", component: ReportsAdministrator,roles:['Administrator', 'Accountant'],hide:false},


  {id:1010,parent_id:null, title:"گزارش تخصیص ها",icon: "ProfileOutlined", path: "/projects/GasProjectProcessListView", component: GasProjectProcessListView,roles:['Employee', 'Engineer', 'Administrative', 'Nezarat'],hide:false},


  {id:1011,parent_id:null, title:"مدیریت پرداخت مهندسین",icon: "WalletOutlined", path: "/accounting/EngPayment", component: EngPayment,roles:['Accountant'],hide:false},



  // USERs
  {id:1013,parent_id:null,title:"کاربران", icon: "TeamOutlined", path:"/users", component: USERs,roles:['Administrator'],hide:false},

  // Notifications
  {id:1021,parent_id:null,title:"اطلاعیه‌ها", icon: "BellOutlined", path:"/notifications", component: Notifications,roles:['Administrator'],hide:false},

  // AI Training
  {id:1022,parent_id:null,title:"داده‌های آموزشی AI", icon: "RobotOutlined", path:"/ai-training", component: AiTraining,roles:['Administrator', 'SuperUser'],hide:false},

  
  // this route should be at the end of all other routes
  {id:1014,parent_id:null,title:"",index:1,icon: "UserOutlined", path: "/", exact: true,
   component: () => <Redirect to="/dashboard" />,roles:['Executor', 'Administrator', 'Engineer', 'Accountant'],hide:false },
   
   // inside route
   {id:1015,parent_id:null, title:"پرونده مهندس",icon: "FileTextOutlined", path: "/projects/GasProjectProcessEng/:id", component: GasProjectDashboardEng,roles:[ 'Engineer', ],hide:true},
   {id:1016,parent_id:null,title:"پروفایل",icon: "UserOutlined", path: "/profile", component: UserProfile,roles:['Administrator','Executor', 'Engineer', 'Accountant','Employee','Installer','Nezarat'] ,hide:false},
   {id:1017,parent_id:null,title:"نقشه GIS",icon: "EnvironmentOutlined", path: "/projects/gis", component: GasProjectGisIndex,roles:['Administrator'],hide:false},


 
  // Piping Plan
    {id:1019,parent_id:null, title:"ترسیم پلان",icon: "AppstoreOutlined", path: "/plan", component: PipingPlan,roles:['Administrator'],hide:false},

  // Git Commits History
    {id:1023,parent_id:null, title:"تاریخچه تغییرات",icon: "BranchesOutlined", path: "/git-commits", component: GitCommits,roles:['Administrator', 'SuperUser'],hide:false},

    // Nezarat
  {id:1026,parent_id:null,title:"پرونده ها", icon: "SafetyCertificateOutlined", path:"/nezarat", component: ListGasProjectNezarat,roles:['Nezarat'],hide:false},


  ]

const authRoutes = [
  { path: "/logout", component: Logout ,hide:false},
  { path: "/login", component: Login,hide:false },
  { path: "/forgot-password", component: ForgetPwd,hide:false },
  { path: "/submit-sms", component: SubmitSms,hide:false },
  { path: "/sp", component: SubmitPackage,hide:false },
  { path: "/tp", component: TransactionPublic,hide:false },
  // { path: "/home", component: LandingPage,hide:false }
  
]




export { userRoutes, authRoutes }
